var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00195 18H30.002V25.5C30.002 28.8137 27.3157 31.5 24.002 31.5H12.002C8.68824 31.5 6.00195 28.8137 6.00195 25.5V18ZM9.00195 21V25.5C9.00195 27.1569 10.3451 28.5 12.002 28.5H24.002C25.6588 28.5 27.002 27.1569 27.002 25.5V21H9.00195Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49805 15.0002C4.49805 12.515 6.51277 10.5002 8.99805 10.5002H26.998C29.4833 10.5002 31.498 12.515 31.498 15.0002V16.5002C31.498 18.9855 29.4833 21.0002 26.998 21.0002H8.99805C6.51277 21.0002 4.49805 18.9855 4.49805 16.5002V15.0002ZM8.99805 13.5002C8.16962 13.5002 7.49805 14.1718 7.49805 15.0002V16.5002C7.49805 17.3287 8.16962 18.0002 8.99805 18.0002H26.998C27.8265 18.0002 28.498 17.3287 28.498 16.5002V15.0002C28.498 14.1718 27.8265 13.5002 26.998 13.5002H8.99805Z",
    fill: "#ffbb00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 9C10.5 6.51472 12.5147 4.5 15 4.5C16.1525 4.5 17.2039 4.93328 18 5.64584C18.7961 4.93328 19.8475 4.5 21 4.5C23.4853 4.5 25.5 6.51472 25.5 9C25.5 11.4853 23.4853 13.5 21 13.5H19.5V31.5H16.5V13.5H15C12.5147 13.5 10.5 11.4853 10.5 9ZM16.5 10.5V9C16.5 8.17157 15.8284 7.5 15 7.5C14.1716 7.5 13.5 8.17157 13.5 9C13.5 9.82843 14.1716 10.5 15 10.5H16.5ZM19.5 9V10.5H21C21.8284 10.5 22.5 9.82843 22.5 9C22.5 8.17157 21.8284 7.5 21 7.5C20.1716 7.5 19.5 8.17157 19.5 9Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/Gift.11ab48913569ab401f5ba50a3d1222b4.svg";
export { ForwardRef as ReactComponent };